import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HomeOutlined, GridViewOutlined, Search, PersonOutline } from '@mui/icons-material';
import { useWebLocale } from '../../contexts/WebLocaleContext';
import '../../styles/AppParity.css';

export function primarySection(path) {
  if (path === '/') return 'home';
  if (/^\/(explore|albums|reviews|lists)(\/|$)/.test(path)) return 'explore';
  if (/^\/search(\/|$)/.test(path)) return 'search';
  if (/^\/mypage(\/|$)/.test(path)) return 'my';
  return null;
}
export function showPrimaryNavigation(path) {
  if (/^\/mypage\/archive\/?$/.test(path)) return false;
  if (
    /^\/reviews\/[^/]+(?:\/user-reviews)?\/?$/.test(path) ||
    /^\/reviews\/(?:local|apple_music|spotify|postpop)\/[^/]+(?:\/user-reviews)?\/?$/i.test(path)
  )
    return true;
  return /^\/(?:explore(?:\/timeline)?|albums|reviews|lists|search(?:\/(?:summary|[^/]+))?|mypage(?:\/[^/]+)?)?\/?$/.test(
    path,
  );
}

export function useKeyboardOpen() {
  const [keyboardOpen, setKeyboardOpen] = useState(false);
  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport) return undefined;
    const update = () => {
      const editing = document.activeElement?.matches('input,textarea,[contenteditable="true"]');
      setKeyboardOpen(Boolean(editing && window.innerHeight - viewport.height > 150));
    };
    update();
    viewport.addEventListener('resize', update);
    document.addEventListener('focusin', update);
    document.addEventListener('focusout', update);
    return () => {
      viewport.removeEventListener('resize', update);
      document.removeEventListener('focusin', update);
      document.removeEventListener('focusout', update);
    };
  }, []);
  return keyboardOpen;
}

export default function MobilePrimaryNavigation() {
  const { pathname } = useLocation();
  const { t } = useWebLocale();
  const keyboardOpen = useKeyboardOpen();
  if (!showPrimaryNavigation(pathname)) return null;
  const active = primarySection(pathname);
  return (
    <nav
      className="pp-primary-nav"
      aria-label={t('navigation')}
      aria-hidden={keyboardOpen || undefined}
      style={keyboardOpen ? { visibility: 'hidden', pointerEvents: 'none' } : undefined}
    >
      {[
        ['/', 'home', HomeOutlined],
        ['/explore', 'explore', GridViewOutlined],
        ['/search', 'search', Search],
        ['/mypage', 'my', PersonOutline],
      ].map(([to, key, Icon]) => (
        <Link
          key={key}
          to={to}
          tabIndex={keyboardOpen ? -1 : undefined}
          aria-current={active === key ? 'page' : undefined}
          className={active === key ? 'pp-primary-active' : ''}
        >
          <Icon aria-hidden="true" />
          <span>{t(key)}</span>
        </Link>
      ))}
    </nav>
  );
}
